module.exports = __webpack_public_path__ + "9788f41e/img/pdf-icon.79f04a36.svg";